"use strict";

var _interopRequireDefault = require("/build-app/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
require("core-js/modules/es6.reflect.construct");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _classCallCheck2 = _interopRequireDefault(require("/build-app/node_modules/@babel/runtime-corejs2/helpers/classCallCheck.js"));
var _createClass2 = _interopRequireDefault(require("/build-app/node_modules/@babel/runtime-corejs2/helpers/createClass.js"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("/build-app/node_modules/@babel/runtime-corejs2/helpers/possibleConstructorReturn.js"));
var _getPrototypeOf2 = _interopRequireDefault(require("/build-app/node_modules/@babel/runtime-corejs2/helpers/getPrototypeOf.js"));
var _inherits2 = _interopRequireDefault(require("/build-app/node_modules/@babel/runtime-corejs2/helpers/inherits.js"));
var _serviceBase = _interopRequireDefault(require("@/services/service-base"));
var _qs = _interopRequireDefault(require("qs"));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2.default)(o), (0, _possibleConstructorReturn2.default)(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2.default)(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
// 权限设置
var domain_p = process.env.VUE_APP_BASE_API_LOGIN;
var WhiteService = /*#__PURE__*/function (_Service) {
  function WhiteService() {
    (0, _classCallCheck2.default)(this, WhiteService);
    return _callSuper(this, WhiteService, arguments);
  }
  (0, _inherits2.default)(WhiteService, _Service);
  return (0, _createClass2.default)(WhiteService, [{
    key: "whiteList",
    value:
    // 列表
    function whiteList(param) {
      return this.http.get("/api/v4/ip?".concat(_qs.default.stringify(param)));
    }
    // 添加
  }, {
    key: "addWhite",
    value: function addWhite(body) {
      return this.http.post('/api/v4/ip', body);
    }

    // 修改
  }, {
    key: "compile",
    value: function compile(id, body) {
      return this.http.put('/api/v4/ip/' + id, body);
    }
    // 详情
  }, {
    key: "details",
    value: function details(id) {
      return this.http.get('/api/v4/ip/' + id);
    }
    // 删除(批量删除)
  }, {
    key: "ipDelete",
    value: function ipDelete(data) {
      return this.http.post('/api/v4/ip/delete', data);
    }
    // 验证登陆ip是否在白名单中
  }, {
    key: "ifWhite",
    value: function ifWhite() {
      return this.http.get('/api/v4/val_login_lp', {
        headers: {
          user: localStorage.getItem('name'),
          group: encodeURIComponent(localStorage.getItem('roleIdsName'))
        }
      });
    }
    // 工单修改登陆账号密码
  }, {
    key: "editpwd",
    value: function editpwd(body) {
      body.pid = process.env.VUE_APP_PID;
      return this.http.post(domain_p + '/vwk/user/editpwd', body);
    }
  }]);
}(_serviceBase.default);
var _default = exports.default = new WhiteService();